import React from 'react'
import PropTypes from 'prop-types'
import PropShapes from 'src/prop-shapes'
import { FormattedMessage } from 'react-intl'
import { If, Text } from 'src/Components'
import Avatar from 'src/Components/shared/Avatar'
import Question from 'src/Components/shared/Questions/QuestionSingleContainer'
import { QUESTIONS } from 'src/constants/messages'
import { safeExternal } from 'src/helpers/links'

import styles from './Single.module.scss'

const propTypes = {
  sponsor: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    profileUrl: PropTypes.string
  }),
  topic: PropShapes.Message.isRequired,
  question: PropShapes.Message,
  placeholder: PropShapes.Message
}

const defaultProps = {
  placeholder: QUESTIONS.placeholder
}

const Single = ({
  customerProfile,
  disableCospo,
  intl,
  sponsor,
  topic,
  question,
  placeholder
}) => {
  let sponsorText = `${sponsor.firstName} ${sponsor.lastName}`

  if (sponsor.websiteUri) {
    sponsorText = (
      <a
        href={safeExternal(sponsor.websiteUri)}
        target='_blank'
        rel='noreferrer noopener'
      >
        {sponsorText}
      </a>
    )
  }

  const profilePhoto = sponsor.photoUri || customerProfile.photoUri

  return (
    <div className={styles.container}>
      <div className={styles.col}>
        <Avatar src={profilePhoto} className={styles.avatar} />
        <div className={styles.profile}>
          <Text className={styles.headline}>
            <FormattedMessage
              id='Homeowner.question.heading'
              defaultMessage='Do you have any questions?'
            />
          </Text>
          <If condition={sponsor.id}>
            <Text className={styles.content}>
              <FormattedMessage
                id='Homeowner.question.sponsorText'
                defaultMessage='{sponsor} is a lender {agent} recommends to answer questions'
                values={{
                  sponsor: sponsorText,
                  agent: `${customerProfile.firstName}`
                }}
              />
            </Text>
          </If>
        </div>
      </div>
      <div className={styles.col}>
        <div className={styles.message}>
          <Question
            questionTopic={intl.formatMessage(topic)}
            placeholder={intl.formatMessage(placeholder)}
            question={question && intl.formatMessage(question)}
            className={styles.question}
            disableCospo={disableCospo}
          />
        </div>
      </div>
    </div>
  )
}

Single.propTypes = propTypes
Single.defaultProps = defaultProps

export default Single
